module.exports = __webpack_public_path__ + "static/media/image1.d9669043.png";